 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"BackToTop":"BackToTop","BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4":"BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4","BarChart":"BarChart","LineChart":"LineChart","MixedChat":"MixedChat","dashboard":"dashboard","CountTo~draggable-kanban":"CountTo~draggable-kanban","draggable-kanban":"draggable-kanban","CountTo~draggable-table~permission-role":"CountTo~draggable-table~permission-role","CountTo":"CountTo","draggable-table":"draggable-table","clipboard":"clipboard","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16","data_orderincome":"data_orderincome","data_playernew":"data_playernew","data_playeronline":"data_playeronline","data_playerretained":"data_playerretained","data_shopbuy":"data_shopbuy","complex-table~permission-role~server_zone":"complex-table~permission-role~server_zone","complex-table":"complex-table","data_ordersearch~player_query":"data_ordersearch~player_query","data_ordersearch":"data_ordersearch","export-excel":"export-excel","game_clienterror":"game_clienterror","game_clientsuggest":"game_clientsuggest","merge-header":"merge-header","player_bagitemlog":"player_bagitemlog","select-excel":"select-excel","server_log":"server_log","upload-excel":"upload-excel","zip":"zip","permission-role":"permission-role","server_zone":"server_zone","componentMixin":"componentMixin","data_gamebattle":"data_gamebattle","data_gamerecord":"data_gamerecord","data_orderfaillog":"data_orderfaillog","player_query":"player_query","draggable-dialog":"draggable-dialog","dynamic-table":"dynamic-table","error-page-401":"error-page-401","error-page-404":"error-page-404","example-create~example-edit~game_mail~game_notice~tinymce":"example-create~example-edit~game_mail~game_notice~tinymce","example-create~example-edit":"example-create~example-edit","example-create":"example-create","example-edit":"example-edit","game_mail":"game_mail","game_notice":"game_notice","tinymce":"tinymce","example-list":"example-list","game_serverkey":"game_serverkey","guide":"guide","inline-edit-table":"inline-edit-table","menu1":"menu1","menu1-1":"menu1-1","menu1-2":"menu1-2","menu1-2-1":"menu1-2-1","menu1-2-2":"menu1-2-2","menu1-3":"menu1-3","menu2":"menu2","pdf":"pdf","permission-directive":"permission-directive","permission-page":"permission-page","profile":"profile","redirect":"redirect","server_process":"server_process","sticky":"sticky","tab":"tab","theme":"theme","userManager":"userManager"}[chunkId]||chunkId) + "." + {"BackToTop":"ad613690","BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4":"7eb96ea8","BarChart":"7e7f23f6","LineChart":"0b56a268","MixedChat":"f6356b90","dashboard":"e5819f9d","CountTo~draggable-kanban":"d8bd9cdd","draggable-kanban":"f7e7c0a4","CountTo~draggable-table~permission-role":"45bbdac6","CountTo":"86809b4c","draggable-table":"fae61ab4","clipboard":"d98450be","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0":"dc9bfbac","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b":"72b306b0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16":"180986a4","data_orderincome":"086fa34c","data_playernew":"c0ac7b31","data_playeronline":"857dc234","data_playerretained":"1e173d88","data_shopbuy":"39d1f64a","complex-table~permission-role~server_zone":"615e9644","complex-table":"0e58f7a6","data_ordersearch~player_query":"b10574e6","data_ordersearch":"ee2f0ba5","export-excel":"cb2684a9","game_clienterror":"1521e927","game_clientsuggest":"4743803e","merge-header":"f2984583","player_bagitemlog":"e803e4ee","select-excel":"ec003e0f","server_log":"8e2de9c7","upload-excel":"67d1ce5d","zip":"32568648","permission-role":"79a2f531","server_zone":"538bd031","componentMixin":"3bebabea","data_gamebattle":"aca326a0","data_gamerecord":"d87935e0","data_orderfaillog":"5284fd3e","player_query":"9f664045","draggable-dialog":"134f8d41","dynamic-table":"b6994394","error-page-401":"32913d9a","error-page-404":"624da27b","example-create~example-edit~game_mail~game_notice~tinymce":"950ce23e","example-create~example-edit":"7c979290","example-create":"02597a04","example-edit":"d255cf05","game_mail":"5e4ea27f","game_notice":"2945314d","tinymce":"d4dc6adf","example-list":"31d22c20","game_serverkey":"94d17d3f","guide":"0613dcfb","inline-edit-table":"0820e8bb","menu1":"145af41f","menu1-1":"b7218054","menu1-2":"c83e906e","menu1-2-1":"8832818b","menu1-2-2":"9f87c550","menu1-3":"579d7362","menu2":"cbc692fa","pdf":"cc67e4a5","permission-directive":"d702595c","permission-page":"37131c39","profile":"fa4d9d7e","redirect":"73a148e4","server_process":"a36d650e","sticky":"1f0ffbc5","tab":"3a0ca5cd","theme":"7f8baef1","userManager":"c9d6db4d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BackToTop":1,"BarChart":1,"LineChart":1,"MixedChat":1,"dashboard":1,"draggable-kanban":1,"CountTo":1,"draggable-table":1,"data_orderincome":1,"data_playernew":1,"data_playeronline":1,"data_playerretained":1,"data_shopbuy":1,"export-excel":1,"upload-excel":1,"permission-role":1,"componentMixin":1,"player_query":1,"draggable-dialog":1,"error-page-401":1,"error-page-404":1,"example-create~example-edit~game_mail~game_notice~tinymce":1,"example-create~example-edit":1,"game_mail":1,"game_notice":1,"tinymce":1,"example-list":1,"guide":1,"inline-edit-table":1,"pdf":1,"permission-directive":1,"profile":1,"server_process":1,"sticky":1,"tab":1,"theme":1,"userManager":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"BackToTop":"BackToTop","BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4":"BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4","BarChart":"BarChart","LineChart":"LineChart","MixedChat":"MixedChat","dashboard":"dashboard","CountTo~draggable-kanban":"CountTo~draggable-kanban","draggable-kanban":"draggable-kanban","CountTo~draggable-table~permission-role":"CountTo~draggable-table~permission-role","CountTo":"CountTo","draggable-table":"draggable-table","clipboard":"clipboard","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16":"complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16","data_orderincome":"data_orderincome","data_playernew":"data_playernew","data_playeronline":"data_playeronline","data_playerretained":"data_playerretained","data_shopbuy":"data_shopbuy","complex-table~permission-role~server_zone":"complex-table~permission-role~server_zone","complex-table":"complex-table","data_ordersearch~player_query":"data_ordersearch~player_query","data_ordersearch":"data_ordersearch","export-excel":"export-excel","game_clienterror":"game_clienterror","game_clientsuggest":"game_clientsuggest","merge-header":"merge-header","player_bagitemlog":"player_bagitemlog","select-excel":"select-excel","server_log":"server_log","upload-excel":"upload-excel","zip":"zip","permission-role":"permission-role","server_zone":"server_zone","componentMixin":"componentMixin","data_gamebattle":"data_gamebattle","data_gamerecord":"data_gamerecord","data_orderfaillog":"data_orderfaillog","player_query":"player_query","draggable-dialog":"draggable-dialog","dynamic-table":"dynamic-table","error-page-401":"error-page-401","error-page-404":"error-page-404","example-create~example-edit~game_mail~game_notice~tinymce":"example-create~example-edit~game_mail~game_notice~tinymce","example-create~example-edit":"example-create~example-edit","example-create":"example-create","example-edit":"example-edit","game_mail":"game_mail","game_notice":"game_notice","tinymce":"tinymce","example-list":"example-list","game_serverkey":"game_serverkey","guide":"guide","inline-edit-table":"inline-edit-table","menu1":"menu1","menu1-1":"menu1-1","menu1-2":"menu1-2","menu1-2-1":"menu1-2-1","menu1-2-2":"menu1-2-2","menu1-3":"menu1-3","menu2":"menu2","pdf":"pdf","permission-directive":"permission-directive","permission-page":"permission-page","profile":"profile","redirect":"redirect","server_process":"server_process","sticky":"sticky","tab":"tab","theme":"theme","userManager":"userManager"}[chunkId]||chunkId) + "." + {"BackToTop":"77ef4f13","BarChart~LineChart~MixedChat~dashboard~data_orderincome~data_playernew~data_playeronline~data_player~28404df4":"31d6cfe0","BarChart":"06293db7","LineChart":"f56811b5","MixedChat":"4411441e","dashboard":"0eebb49e","CountTo~draggable-kanban":"31d6cfe0","draggable-kanban":"654b7bd6","CountTo~draggable-table~permission-role":"31d6cfe0","CountTo":"c2f806f2","draggable-table":"292a3f48","clipboard":"31d6cfe0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~45963bb0":"31d6cfe0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~89babd4b":"31d6cfe0","complex-table~data_orderincome~data_ordersearch~data_playernew~data_playeronline~data_playerretained~d8d90c16":"31d6cfe0","data_orderincome":"0cad898b","data_playernew":"637d92a3","data_playeronline":"5487fee1","data_playerretained":"87c40c52","data_shopbuy":"5c078006","complex-table~permission-role~server_zone":"31d6cfe0","complex-table":"31d6cfe0","data_ordersearch~player_query":"31d6cfe0","data_ordersearch":"31d6cfe0","export-excel":"48569099","game_clienterror":"31d6cfe0","game_clientsuggest":"31d6cfe0","merge-header":"31d6cfe0","player_bagitemlog":"31d6cfe0","select-excel":"31d6cfe0","server_log":"31d6cfe0","upload-excel":"f114875d","zip":"31d6cfe0","permission-role":"19997a47","server_zone":"31d6cfe0","componentMixin":"519b0452","data_gamebattle":"31d6cfe0","data_gamerecord":"31d6cfe0","data_orderfaillog":"31d6cfe0","player_query":"d1a078ab","draggable-dialog":"bb0ac997","dynamic-table":"31d6cfe0","error-page-401":"45cacedd","error-page-404":"b4bd5913","example-create~example-edit~game_mail~game_notice~tinymce":"8d86296d","example-create~example-edit":"7e65169e","example-create":"31d6cfe0","example-edit":"31d6cfe0","game_mail":"a4403be8","game_notice":"1b364baa","tinymce":"2cf4e366","example-list":"d4737043","game_serverkey":"31d6cfe0","guide":"e57e304f","inline-edit-table":"4a022994","menu1":"31d6cfe0","menu1-1":"31d6cfe0","menu1-2":"31d6cfe0","menu1-2-1":"31d6cfe0","menu1-2-2":"31d6cfe0","menu1-3":"31d6cfe0","menu2":"31d6cfe0","pdf":"17e7bbe6","permission-directive":"0102e12a","permission-page":"31d6cfe0","profile":"c9be6e4f","redirect":"31d6cfe0","server_process":"a8efea3f","sticky":"e0c8d6d7","tab":"1e51bd66","theme":"2035284b","userManager":"42df24f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
